import React, { useContext } from "react";
import { defined } from "../../shared/utilities/typeHelper";
import { User } from "../api/identityApi.types";

export const UserContext = React.createContext<User | undefined>(undefined);

export const useUserContext = () => {
  const user = useContext(UserContext);
  return defined(user);
};
